export var Locale;
(function (Locale) {
    Locale["nl_NL"] = "nl-NL";
    Locale["nl_BE"] = "nl-BE";
    Locale["en_US"] = "en-US";
})(Locale || (Locale = {}));
export const DEFAULT_LOCALE = Locale.nl_NL;
